import { CompanyTitledPage } from "../../TitledPage";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import Button from "@mui/material/Button";

import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../../components/PartHeader";
import useInputObject from "../../../hooks/useInputObject";
import {
  getProductDetail,
  updateProductDetail,
} from "../../../http/api/ProductDetailAPI";
import ProductDetailInfo from "../ProductDetailInfo/ProductDetailInfo";
import { ScreenStatusContext } from "../../../context/ScreenStatusContext";
import { confirmWhenChanged } from "../../../utils/validation";

const infoTableCellSx = {
  fontSize: 18,
};

// 商品明細編集ページ
export default function ProductDetailEditPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const productId = location.state.productId;
  const productDetailId = location.state.productDetailId;
  const productDetail = useInputObject({});

  // 更新中をあらわすstate
  const [isUpdating, setUpdating] = useState(false);
  // 画面ステータスをcontextから取得
  const {isChanged} = useContext(ScreenStatusContext);

  //商品明細情報を取得
  useEffect(() => {
    GetProductDetailInfo();
  }, []);
  async function GetProductDetailInfo() {
    let response = await getProductDetail({ productId, productDetailId });
    productDetail.setValue(response.listProductDetailInfo[0]);
  }

  // 戻るボタンをクリック
  const onClickReturn = (event) => {
    if (confirmWhenChanged(isChanged)) {
      navigate(-1);
    }
  };

  // 更新ボタンをクリック
  const onClickUpdate = async (event) => {
    setUpdating(true);

    productDetail.Value.productId = productId;
    productDetail.Value.productDetailId = productDetailId;
    productDetail.Value.updatedId = 1; //TODO JWTを追加した後削除
    await updateProductDetail(productDetail.Value);
    alert("商品明細を更新しました。");
    navigate("/company/product", { state: { productId } });
  };

  return (
    <CompanyTitledPage title="商品明細編集">
      <CompanyPartHeader>
        <Grid container spacing={1}>
          <Grid item xs>
            <Typography fontWeight="bold" fontSize={20}>
              商品明細の入力
            </Typography>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained" onClick={onClickUpdate} disabled={isUpdating}>
              更新
            </Button>
          </Grid>
          <Grid item xs="auto">
            <Button variant="outlined" onClick={onClickReturn}>
              戻る
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>

      <ProductDetailInfo productId={productId} productDetail={productDetail} />
    </CompanyTitledPage>
  );
}
